// extracted by mini-css-extract-plugin
export default {"container":"styles_container__c3l4q","item":"styles_item__TdGUn","title":"styles_title__M2NNH","content":"styles_content__5wHWz"};